import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import * as Sentry from '@sentry/react';
import App from './App';
import ErrorFallback from './components/ErrorFallback';
import './index.css';

try {
  const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (SENTRY_DSN) {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: import.meta.env.MODE,
      // 20% sampling: enough signal without log noise. Raise to 1.0
      // temporarily when diagnosing a specific latency issue, then revert.
      tracesSampleRate: 0.2,
      // Connects frontend traces to backend traces by propagating the
      // sentry-trace + baggage headers to api.swipeopinion.com.
      tracePropagationTargets: ['api.swipeopinion.com'],
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: true,
          blockAllMedia: false,
        }),
      ],
      replaysSessionSampleRate: 0.05,
      replaysOnErrorSampleRate: 1.0,
    });
  }
} catch {
  // Sentry init failure should never crash the app
}

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);












